import { pascalCase } from 'change-case';
import { TransactionCardNetworkCode } from '~/enums/transactions/transaction-card-network.enum';
import { TransactionDigitalWalletCode } from '~/enums/transactions/transaction-digital-wallet.enum';

export const cardNetworkScheme = (cardNetwork?: string) => {
  if (cardNetwork) {
    const scheme =
      TransactionCardNetworkCode[
        capitalize(cardNetwork.trim()) as keyof typeof TransactionCardNetworkCode
      ];
    if (scheme) {
      return scheme !== 'CB' ? capitalize(scheme) : 'CB';
    }
  }
  return 'DefaultCardLogo';
};

export const digitalWalletScheme = (digitalWallet?: string) => {
  if (digitalWallet) {
    const scheme = pascalCase(
      TransactionDigitalWalletCode[
        capitalize(digitalWallet) as keyof typeof TransactionDigitalWalletCode
      ]
    );
    return scheme;
  }
  return undefined;
};
